module.exports = __webpack_public_path__ + "static/img/jd-img2.e094139.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/jd-img2.png
// module id = 829
// module chunks = 0